import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import Keycloak, { KeycloakProfile } from 'keycloak-js';
import { mergeMap, from, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import * as UserActions from './user.actions';
import { User } from './user.model';

@Injectable()
export class UserEffects {

  private actions$ = inject(Actions);
  private keycloak = inject(Keycloak);

  loadUser$ = createEffect(() => this.actions$.pipe(
    ofType(UserActions.loadUser),
    mergeMap(() =>
      from(this.keycloak.loadUserProfile() as Promise<KeycloakProfile>).pipe(
        map((profile) => {
          const realmAccess = this.keycloak.realmAccess;
          const userRoles = realmAccess?.roles || [];
          const user = new User(
            profile,
            userRoles,
            this.keycloak.tokenParsed as any
          );
          return UserActions.loadUserSuccess({ user });
        }),
        catchError(error => of(UserActions.loadUserFailure({ error })))
      )
    )
  ));
}
